import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { useJiraWorkmanagementProjectNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { type RouteContext, Redirect } from '@atlassian/react-resource-router';

export const ProjectSettingsRedirect = ({ match }: RouteContext): React.JSX.Element | null => {
	const { data, loading } = useJiraWorkmanagementProjectNavigation();
	const { projectKey } = match.params;

	// Wait for nav data to be available before deciding where to redirect on cold loads
	if ((loading || !data) && fg('vmc-52-settings-redirect-wait-till-data-received')) {
		return null;
	}

	if (
		data?.permissionInfo?.isAdmin ||
		data?.permissionInfo?.isSiteAdmin ||
		data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS
	) {
		return <Redirect to={`/jira/core/projects/${String(projectKey)}/settings/details`} />;
	}
	if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) {
		return <Redirect to={`/plugins/servlet/project-config/${String(projectKey)}/workflows`} />;
	}
	if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) {
		return <Redirect to={`/plugins/servlet/project-config/${String(projectKey)}/issuelayout`} />;
	}
	if (fg('vmc-11-manage-versions-permission')) {
		if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) {
			return (
				<Redirect
					to={`/plugins/servlet/project-config/${String(projectKey)}/administer-versions`}
				/>
			);
		}
	}

	return (
		<Redirect to={`/jira/core/projects/${String(match.params.projectKey)}/settings/details`} />
	);
};
